<template>
  <div class="content">
    <h2 class="title">
      <img :src="getSrc" ref="iconImage" :class="{ 'rotate-icon': shouldRotate }"
           class="icon" alt="icon">
      <span class="text">
        {{ selectedEntry.data.title }}
      </span>
    </h2>
    <div class="subtitle-text" v-if="selectedEntry.data.metadata">
      <p class="author" v-if="selectedEntry.data.metadata.author">
            {{ $t('CREATED_BY') }}
        <span class="bold black">
            {{ selectedEntry.data.metadata.author }}
        </span>
      </p>
        <span class="date" v-if="selectedEntry.data.metadata.date">
            {{ $t('CREATED_ON') }}: {{ selectedEntry.data.metadata.date }}
        </span>
    </div>
    <entry-info-component v-if="selectedEntry.data.description" :title="$t('DESCRIPTION')" :description="selectedEntry.data.description"
                          :openByDefault="Boolean(!selectedEntry.data.metadata || (selectedEntry.data.metadata && !selectedEntry.data.metadata.instructions))"/>
    <entry-info-component v-if="selectedEntry.data.metadata && selectedEntry.data.metadata.instructions" :title="$t('INSTRUCTIONS')"
                          :description="selectedEntry.data.metadata.instructions" :openByDefault="!selectedEntry.data.description"/>

<div v-for="field in fields" :key="field.id">
      <entry-info-component  v-if="showEntryInfoComponent(field)" :title="field.title"
                          :description="getDynamicFieldDescription(field.key, field.field_type)" :openByDefault="!selectedEntry.data.description"/>
    </div>
    <entry-usage-bar :type="selectedEntry.object.content_type"/>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import EntryInfoComponent from '@/components/entry-info-component'
import EntryUsageBar from '@/components/entry-usage-bar'
import { getCollectionEntryTypeIcon, shouldRotate } from '@/utilityFunctions'
import { fieldType } from '@/constants'

export default {
  name: 'entry-info-container',
  components: { EntryInfoComponent, EntryUsageBar },
  computed: {
    shouldRotate,
    ...mapState({
      selectedEntry: state => state.collections.selectedEntry,
      fields: state => state.collections.fields
    }),
    getSrc () {
      return getCollectionEntryTypeIcon(this.selectedEntry)
    }
  },
  created () {
    this.$nextTick(function () {
      this.$refs.iconImage.onerror = function () {
        this.src = require('@/assets/images/fileTypeIcons/link_upload.svg')
      }
    })
  },
  methods: {
    showEntryInfoComponent (field) {
      if (this.selectedEntry.data.metadata?.dynamic_fields?.[field.key] && !field.hide_on_viewing && field.field_type !== fieldType.ATTACHMENTS) {
        return true
      } else return false
    },
    getDynamicFieldDescription (index, type) {
      if (type !== fieldType.SELECT_MULTIPLE) {
        return this.selectedEntry.data.metadata.dynamic_fields[index]
      } else {
        return this.selectedEntry.data.metadata.dynamic_fields[index].toString()
      }
    }
  }
}
</script>

<style>

</style>
